<!-- ==========================================================================================
    File Name: getUser.vue
    Description: Get Single User Page
========================================================================================== -->

<template>
        <div id="get-user-page">
                <vx-card>
                        <div>
                                <h5>{{ this.$route.params.id }}</h5>
                        </div>
                </vx-card>
        </div>
</template>

<script>
export default {
        components: {},
        data() {
                return {};
        },
        computed: {},
        methods: {},
};
</script>
